import { useNavigate } from "react-router-dom";

const Nemt = () => {
  const pageStyle = {
    maxWidth: "1000px",
    margin: "0 auto",
    padding: "20px",
  };

  const buttonContainer = {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
  };
  const navigate = useNavigate(); 
  const handleTransportationProvider = () => {
    console.log("Transportation provider clicked");
    window.open("/products/provider/provider-index.html", "_blank");
  };

  const handleProjectPlan = () => {
    console.log("Project plan clicked");
    navigate("/products/nemt/pdf");
  };

  const handleVehicleInspection = () => {
    console.log("Vehicle inspection clicked");
    window.open("/products/vehicle/vehicle-index.html", "_blank");
  };

  return (
    <div style={pageStyle}>
      <h1 style={{ textAlign: "left" }}>
        Non-Emergency Medical Transportation (NEMT) Consulting & Software Solutions
      </h1>

      <p align="left">
      At Internet Software Works (ISW), we specialize in helping 
      Non-Emergency Medical Transportation (NEMT) providers improve 
      operational efficiency, regulatory compliance, and 
      customer satisfaction through modern software solutions 
      and industry expertise.
      </p>
      <br />
      <p align="left">
      With extensive experience developing transportation management 
      systems, scheduling applications, mobile solutions, and 
      provider portals, we understand the unique challenges 
      facing NEMT organizations. Our solutions are designed to 
      streamline daily operations, reduce administrative overhead, 
      and support sustainable growth.
      </p>

      <h3 style={{ textAlign: "center" }}>
        Our NEMT Consulting Services Include:
      </h3>

      {/* Normal bullets */}
      <ul align="left">
        <li>Custom NEMT software design and development</li>
        <li>Automated scheduling and dispatch solutions</li>
        <li>Route optimization and GPS integration</li>
        <li>Driver, vehicle, and fleet management systems</li>
        <li>Patient and member management portals</li>
        <li>Compliance, credentialing, and regulatory support</li>
        <li>Real-time reporting, analytics, and business intelligence</li>
        <li>Mobile applications for drivers, dispatchers, and members</li>
        <li>Integration with healthcare providers, brokers, and insurance systems</li>
        <li>Cloud migration, modernization, and ongoing technical support</li>
      </ul>

      <h3>Technology Solutions Built for NEMT Providers</h3>
      <h3>Optimize Your NEMT Operations</h3>

      <p>SW delivers scalable, cloud-based solutions that help transportation providers manage every aspect of their operation, including:</p>
      <ul align="left">
        <li>Transportation provider onboarding and credential management</li>
        <li>Driver enrollment and qualification tracking</li>
        <li>Vehicle inspections and maintenance management</li>
        <li>Trip scheduling and dispatch operations</li>
        <li>Call center and customer service workflows</li>
        <li>Document management and electronic signatures</li>
        <li>Automated notifications via email and SMS</li>
        <li>Performance reporting and operational dashboards</li>
        </ul>

      <h3>Optimize Your NEMT Operations</h3>
      <p>
      Whether you are launching a new NEMT business, modernizing 
      legacy systems, or expanding your current operation, ISW can 
      help you implement technology solutions that improve efficiency, 
      enhance service quality, and support regulatory compliance.
      </p>
      <br/>
      <p>Our goal is simple: provide reliable, 
        cost-effective software solutions that allow NEMT 
        providers to focus on what matters most—delivering safe, 
        dependable transportation services to their members and 
        patients.
      </p>
      <h3>Sample Solutions</h3>
      <p>Explore examples of NEMT solutions developed by ISW:</p>
      <ul>
        <li>Transportation Provider Registration Portal</li>
        <li>NEMT Project Planning and System Architecture</li>
        <li>Vehicle Inspection and Fleet Management Application</li>
      </ul>
      <p>This version positions ISW more as a specialized software 
        and consulting firm rather than a generic consultant and 
        aligns well with the NEMT applications you've been building, 
        including provider registration, trip management, and vehicle 
        inspection systems.
      </p>

      <div style={buttonContainer}>
        <button onClick={handleTransportationProvider}>
          Transportation Provider Register
        </button>

        <button onClick={handleProjectPlan}>
          View NEMT Project Plan
        </button>

        <button onClick={handleVehicleInspection}>
          Vehicle Inspection
        </button>
      </div>
    </div>
  );
};

export default Nemt;
